import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { FieldOperationsSensorsListingFiltersSourceService } from './field-operations-sensors-listing-filters-source.service';
import { FieldOperationsSensorsListingDataSourceService } from './field-operations-sensors-listing-data-source.service';
import { FieldOperationsSensorsListingExportConfigService } from './field-operations-sensors-listing-export-config.service';
import { FieldOperationsSensorsListingModelService } from './field-operations-sensors-listing-model.service';

export const provideFieldOperationsSensorsListing = (): (Provider | EnvironmentProviders)[] => [
  FieldOperationsSensorsListingFiltersSourceService,
  FieldOperationsSensorsListingDataSourceService,
  FieldOperationsSensorsListingExportConfigService,
  { provide: LISTING_MODEL, useClass: FieldOperationsSensorsListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
